export default __webpack_public_path__ + "static/media/Video.bbb15509.svg";